/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "user-center"
};
const _hoisted_2 = {
  class: "flex"
};
import { useUserStore } from '@/store/modules/user';
import EditPassword from './module/editPassword.vue';
import EditPhone from './module/editPhone.vue';
import EditEmail from './module/editEmail.vue';
import EditNickName from './module/editNickName.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'userCenter',
  setup(__props) {
    const TeamManage = defineAsyncComponent(() => import('./teamManage.vue'));
    const RoleGroup = defineAsyncComponent(() => import('./roleGroup.vue'));
    const {
      getUserInfo
    } = useUserStore();
    const userInfo = computed(() => useUserStore().userInfo);
    const teamManageRef = ref();
    const userInfoActive = ref('userInfo');
    const teamManageActive = ref('teamManage');
    const roleCurrentOperate = ref('add');
    const userInfoPanes = [{
      title: '账户信息',
      key: 'userInfo',
      level: 0
    }, {
      title: '修改昵称',
      key: 'editNickName',
      level: 1
    }, {
      title: '修改手机号',
      key: 'editPhone',
      level: 1
    }, {
      title: '修改邮箱',
      key: 'editEmail',
      level: 1
    }, {
      title: '修改密码',
      key: 'editPassword',
      level: 1
    }];
    const teamPanes = computed(() => {
      return [{
        title: '团队管理',
        key: 'teamManage',
        level: 0
      }, {
        title: '角色组',
        key: 'roleGroup',
        level: 1
      }, {
        title: `${roleCurrentOperate.value === 'add' ? '添加角色组' : roleCurrentOperate.value === 'edit' ? '编辑角色组' : '角色组详情'}`,
        key: 'addEditRoleGroup',
        level: 1
      }];
    });
    const accountInfo = ref([{
      key: '',
      type: 'role_name',
      label: '角色'
    }, {
      key: '',
      type: 'UserName',
      label: '昵称'
    }, {
      key: '',
      type: 'Email',
      label: '邮箱'
    }, {
      key: '',
      type: 'Phone',
      label: '手机号'
    }, {
      key: '',
      type: 'Password',
      label: '密码'
    }]);
    const handleBackUserInfo = () => {
      userInfoActive.value = 'userInfo';
    };
    const handleEdit = item => {
      item.type === 'Phone' && (userInfoActive.value = 'editPhone');
      item.type === 'Email' && (userInfoActive.value = 'editEmail');
      item.type === 'Password' && (userInfoActive.value = 'editPassword');
      item.type === 'UserName' && (userInfoActive.value = 'editNickName');
    };
    const handleActive = (type, op) => {
      teamManageActive.value = type;
      roleCurrentOperate.value = op;
    };
    const handleOpenAddAccount = () => {
      teamManageRef.value.show();
    };
    const handleSuccess = () => {
      handleBackUserInfo();
      getUserInfo('reload');
    };
    watch(() => userInfo.value, () => {
      accountInfo.value.map(item => {
        if (item.type === 'Password') {
          item.key = '123456';
        } else {
          item.key = userInfo.value[item.type] || '暂无';
        }
      });
    }, {
      immediate: true,
      deep: true
    });
    onMounted(() => {
      getUserInfo();
    });
    return (_ctx, _cache) => {
      const _component_UCard = _resolveComponent("UCard");
      const _component_el_input = __unplugin_components_0;
      const _component_el_button = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      const _directive_has = _resolveDirective("has");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_UCard, {
        disabled: ""
      }, {
        title: _withCtx(() => [_createTextVNode(" 企业信息 ")]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_unref(userInfo).Company), 1)]),
        _: 1
      }), _createVNode(_component_u_card, {
        class: "marginT20",
        modelValue: _unref(userInfoActive),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(userInfoActive) ? userInfoActive.value = $event : null),
        panes: userInfoPanes,
        onBack: handleBackUserInfo
      }, {
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "userInfo"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "120px"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountInfo), (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: "marginT20",
                key: index
              }, [_createVNode(_component_el_form_item, {
                label: item.label
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
                  modelValue: item.key,
                  "onUpdate:modelValue": $event => item.key = $event,
                  type: item.type === 'Password' ? 'password' : '',
                  disabled: "",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue", "onUpdate:modelValue", "type"]), item.type !== 'role_name' ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  class: "marginL10",
                  onClick: $event => handleEdit(item)
                }, {
                  default: _withCtx(() => [_createTextVNode("修改")]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
                _: 2
              }, 1032, ["label"])]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(EditNickName, {
          onSuccess: handleSuccess
        }), _createVNode(EditEmail, {
          userInfo: _unref(userInfo),
          onSuccess: handleSuccess
        }, null, 8, ["userInfo"]), _createVNode(EditPhone, {
          userInfo: _unref(userInfo),
          onSuccess: handleSuccess
        }, null, 8, ["userInfo"]), _createVNode(EditPassword, {
          userInfo: _unref(userInfo),
          onSuccess: handleSuccess
        }, null, 8, ["userInfo"])]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_UCard, {
        class: "marginT20",
        modelValue: _unref(teamManageActive),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(teamManageActive) ? teamManageActive.value = $event : null),
        panes: _unref(teamPanes),
        "full-screen": ""
      }, _createSlots({
        default: _withCtx(() => [_createVNode(_unref(TeamManage), {
          ref_key: "teamManageRef",
          ref: teamManageRef
        }, null, 512), _createVNode(_unref(RoleGroup), {
          active: _unref(teamManageActive),
          onOnActive: handleActive
        }, null, 8, ["active"])]),
        _: 2
      }, [_unref(teamManageActive) === 'teamManage' ? {
        name: "extra",
        fn: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          link: "",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => teamManageActive.value = 'roleGroup')
        }, {
          default: _withCtx(() => [_createTextVNode("角色组")]),
          _: 1
        })), [[_directive_has, 'roleGroup']]), _unref(userInfo).IsCanAuth ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: handleOpenAddAccount
        }, {
          default: _withCtx(() => [_createTextVNode("添加子账号")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "panes"])), [[_directive_has, 'teamManage']])]);
    };
  }
});